// Imports ------------------------------------------------------------------->

import {Component} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {icons} from "../../icons/Icons";

import {Link} from "../../components/flipp-link/Link";
import {Page} from "../../components/flipp-page/Page";
import {FlyerListingItem, FlyerListingItemContext} from "../../components/flipp-flyer-listing-item/FlyerListingItem";

import {inject} from "../../services/di";
import { Favourites, FavouriteService } from "../../services/FavouriteService";
import {FlyerService} from "../../services/FlyerService";
import {ConfigService} from "../../services/ConfigService";
import {Flyer} from "../../definitions/FlyerDefinitions";
import { AuthenticationService } from "../../services/AuthenticationService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@element("flipp-favourites-page")
export class FavouritesPage extends Component<{}, void> {

	@inject favourites: FavouriteService;
	refs: {
		favourites: FavouritesContent
	};

	onAttach() {
		window.addEventListener("flipp-favourites", this._handleFavouritesChanged);
	}

	onDetach() {
		window.removeEventListener("flipp-favourites", this._handleFavouritesChanged);
	}

	render() {
		return <Page show="flyers">
			<FavouritesContent ref="favourites" />
		</Page>;
	}

	private _handleFavouritesChanged = () => {
		this.refs.favourites.invalidate();
	}
}

type FavouritesContentModel = [Flyer[], Favourites];

// flipp-favourites-page-content ------------------------------------------------------>

@element("flipp-favourites-page-content")
class FavouritesContent extends Component<JSX.HTMLProps, FavouritesContentModel> {

	@inject favourites: FavouriteService;
	@inject flyerService: FlyerService;
	@inject config: ConfigService;
	@inject auth: AuthenticationService;

	prepare() {
		const token = this.auth.user ? this.auth.user.token : null;
		return Promise.all([this.flyerService.getFlyers(), this.favourites.getFavouriteMerchantIds(token)]);
	}

	render([flyers, favMerchants]: FavouritesContentModel) {
		// const favMerchants = this.favourites.getFavouriteMerchantIds();
		const premiumFlyers = flyers.filter((flyer) => flyer.premium && favMerchants.indexOf(flyer.merchantId) !== -1);
		const normalFlyers = flyers.filter((flyer) => !flyer.premium && favMerchants.indexOf(flyer.merchantId) !== -1);

		/* The call to action string has a heart icon in the middle of it. The placement of the heart
			* is marked by [HEART] in the actual string. Our i18n setup does not easily allow us to
			* change/update content, so we need to split up the string (delimin by [HEART]) so we can manually
			* insert the heart icon */
		const desc = i18n("fav_desc").split("[HEART]");
		return <div class="content" fill-absolute>

				<div class="topbar" flex-horizontal>
					<h1 class="title">{i18n("fav_page")}</h1>
				</div>

				<div class="container">
					{ premiumFlyers.map((flyer) =>
						<FlyerListingItem flyerId={flyer.id} context={FlyerListingItemContext.Favourites} premium />) }
				</div>
				<div class="container">
					{ normalFlyers.map((flyer) =>
						<FlyerListingItem flyerId={flyer.id} context={FlyerListingItemContext.Favourites} />) }
				</div>

				{ premiumFlyers.length === 0 && normalFlyers.length === 0 ?
					<div class="empty-favs-container" flex-vertical fill-absolute>
						<h2>{i18n("fav_h2")}</h2>
						<h2>
							{desc[0]}
							<img class="empty-heart" src="https://f.wishabi.net/creative/Distribution/images/icons/favourite-outline.svg" alt=""/>
							{desc[1]}
							<img class="arrow-favourite" src="https://f.wishabi.net/creative/Distribution/images/sl/arrow-left.png" />
						</h2>
						{ window.innerWidth <= 768 ?
							<img class="fav-anim" src="https://f.wishabi.net/creative/Distribution/mobile-favourites.gif" />
						:
							<img class="fav-anim" src="https://f.wishabi.net/creative/Distribution/images/favourites.gif" />
						}
						<Link to="listing">{i18n("empty_clippings_button")}</Link>
					</div>
				: null }
			</div>;
	}

}
